module.exports = __webpack_public_path__ + "img/vid-thumb.bc3d1d88.png";